import { render, staticRenderFns } from "./CapitalImobilizadoCirculanteAbsoluto.vue?vue&type=template&id=464c63da&scoped=true&"
import script from "./CapitalImobilizadoCirculanteAbsoluto.vue?vue&type=script&lang=js&"
export * from "./CapitalImobilizadoCirculanteAbsoluto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c63da",
  null
  
)

export default component.exports